/* VentiloFresh — global interactions */
(function () {
  'use strict';

  const money = (cents) => {
    try {
      return (cents / 100).toLocaleString(window.Shopify?.locale || 'fr', {
        style: 'currency',
        currency: window.VentiloFresh?.currency || 'EUR',
      });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  };

  /* -------- Mobile menu -------- */
  const menu = document.querySelector('[data-mobile-menu]');
  document.querySelectorAll('[data-menu-open]').forEach((b) =>
    b.addEventListener('click', () => menu && menu.classList.add('is-open'))
  );
  document.querySelectorAll('[data-menu-close]').forEach((b) =>
    b.addEventListener('click', () => menu && menu.classList.remove('is-open'))
  );
  if (menu) {
    menu.addEventListener('click', (e) => {
      if (e.target === menu) menu.classList.remove('is-open');
    });
  }

  /* -------- Cart drawer -------- */
  const drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    drawer && drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer && drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.VentiloOpenCart = openDrawer;

  document.querySelectorAll('[data-cart-open]').forEach((b) =>
    b.addEventListener('click', (e) => {
      if (drawer) {
        e.preventDefault();
        openDrawer();
      }
    })
  );
  document.querySelectorAll('[data-cart-close]').forEach((b) =>
    b.addEventListener('click', closeDrawer)
  );
  if (drawer) {
    drawer.addEventListener('click', (e) => {
      if (e.target.matches('.cart-drawer__overlay')) closeDrawer();
    });
  }

  async function refreshCart() {
    try {
      const res = await fetch(window.Shopify?.routes?.root + 'cart.js' || '/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      renderDrawer(cart);
      return cart;
    } catch (e) {
      console.error(e);
    }
  }
  window.VentiloRefreshCart = refreshCart;

  function renderDrawer(cart) {
    const list = document.querySelector('[data-cart-items]');
    if (!list) return;
    if (cart.item_count === 0) {
      list.innerHTML = '<p style="text-align:center;padding:2rem 0;color:var(--color-text-soft)">Votre panier est vide.</p>';
    } else {
      list.innerHTML = cart.items
        .map(
          (item) => `
        <div class="cart-item">
          <img src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_120x$1') : ''}" alt="${item.product_title}">
          <div class="cart-item__info">
            <div class="cart-item__title">${item.product_title}</div>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__price">${item.variant_title}</div>` : ''}
            <div class="cart-item__price">${item.quantity} × ${money(item.final_price)}</div>
            <button class="cart-item__remove" data-line="${item.key}">Retirer</button>
          </div>
          <strong>${money(item.final_line_price)}</strong>
        </div>`
        )
        .join('');
    }

    document.querySelectorAll('[data-cart-total]').forEach((el) => (el.textContent = money(cart.total_price)));

    const bar = document.querySelector('[data-shipping-bar]');
    if (bar) {
      const threshold = parseInt(bar.dataset.threshold, 10) * 100;
      const remaining = threshold - cart.total_price;
      const fill = bar.querySelector('.free-shipping-bar__fill');
      const text = bar.querySelector('.free-shipping-bar__text');
      const pct = Math.min(100, (cart.total_price / threshold) * 100);
      if (fill) fill.style.width = pct + '%';
      if (text) {
        text.innerHTML =
          remaining > 0
            ? `Plus que <strong>${money(remaining)}</strong> pour la livraison offerte&nbsp;🚚`
            : `🎉 Félicitations, vous bénéficiez de la <strong>livraison offerte&nbsp;!</strong>`;
      }
    }

    list.querySelectorAll('[data-line]').forEach((btn) =>
      btn.addEventListener('click', () => updateLine(btn.dataset.line, 0))
    );
  }

  async function updateLine(key, quantity) {
    await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    refreshCart();
  }

  /* -------- Add to cart (AJAX) -------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.innerHTML : '';
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = 'Ajout en cours…';
    }
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error('add failed');
      await refreshCart();
      if (btn) btn.innerHTML = '✓ Ajouté !';
      openDrawer();
      setTimeout(() => {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = original;
        }
      }, 1200);
    } catch (err) {
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = original;
      }
      window.location.href = '/cart';
    }
  });

  /* -------- Quantity selector -------- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((b) =>
      b.addEventListener('click', () => {
        let v = parseInt(input.value, 10) || 1;
        v += b.dataset.qtyStep === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      })
    );
  });

  /* -------- Product gallery -------- */
document.querySelectorAll('[data-gallery]').forEach((gallery) => {
  const main = gallery.querySelector('[data-gallery-main] img');
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) =>
    thumb.addEventListener('click', () => {
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (main && thumb.dataset.full) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumb.dataset.full;
      }
    })
  );
});

  /* -------- Bundle selector -------- */
  document.querySelectorAll('[data-bundle]').forEach((bundle) => {
    const qtyInput = document.querySelector('[data-bundle-qty]');
    bundle.querySelectorAll('.bundle__option').forEach((opt) => {
      opt.addEventListener('click', () => {
        bundle.querySelectorAll('.bundle__option').forEach((o) => o.classList.remove('is-active'));
        opt.classList.add('is-active');
        const radio = opt.querySelector('input');
        if (radio) radio.checked = true;
        if (qtyInput && opt.dataset.qty) {
          qtyInput.value = opt.dataset.qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });

  /* -------- Sticky ATC -------- */
  const sticky = document.querySelector('[data-sticky-atc]');
  const buyBox = document.querySelector('[data-buy-box]');
  if (sticky && buyBox) {
    const io = new IntersectionObserver(
      ([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    io.observe(buyBox);
    sticky.querySelector('[data-sticky-buy]')?.addEventListener('click', () => {
      const mainForm = document.querySelector('[data-product-form]');
      if (mainForm) mainForm.requestSubmit();
    });
  }

  /* -------- Reveal on scroll -------- */
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* -------- Cart page: auto-submit qty changes -------- */
  document.querySelectorAll('[data-cart-qty]').forEach((input) => {
    input.addEventListener('change', () => {
      const form = input.closest('form');
      if (form) form.querySelector('[name="update"]')?.click();
    });
  });

  /* Init cart count on load */
  refreshCart();
})();
